export enum PUNKU_HEADERS {

  AUTHORIZATION = 'Authorization',
  GUID_SISTEMA = 'GUID_SISTEMA',
  GUID_ROL = 'GUID_ROL',
  CODIGO_ENTIDAD = 'CODIGO_ENTIDAD',
  GUID_MENU = 'GUID_MENU',
  GUID_MODULO = 'GUID_MODULO',
  CODIGO_ACCION = 'CODIGO_ACCION'

}
